import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import ResetPasswordPageViewModel from './ResetPasswordPageViewModel.type';

type ResetPasswordPageType = ResetPasswordPageViewModel & PageType;

export default (currentPage: PageType): currentPage is ResetPasswordPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_ResetPassword_ResetPasswordPageViewModel;
};
